import { AppConfigModel } from "../abstract/app-config.model";
import { Authorization } from "./authorization.model";

export class Profile extends AppConfigModel {

    static override CLASS_NAME: string = 'Profile';

    readonly description!: string;
    readonly mfaRecommended!: boolean;
    private _authorizations!: Authorization[];

    public get authorizations(): Authorization[] {
        return this._authorizations;
    }

    public set authorizations(value: any[]) {
        this._authorizations = [];
        for (let i = 0; i < value.length; i++) {
            this._authorizations.push(new Authorization(value[i]));
        }
    }
}
